module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/img/logo.c83971c4.svg";